import MAppointmentCard from '@/components/MAppointmentCard/MAppointmentCard.vue';

export { MAppointmentCard };
export default MAppointmentCard;
